// Module
var code = `{{#artImage}}
<img class="deck-exhibit-art" src="{{attrImageSrc}}" alt="" />
{{/artImage}}
{{#artPlaceholder}}
<div class="deck-placeholder">
  <span class="deck-placeholder-label">{{fileName}}</span>
</div>
{{/artPlaceholder}}
{{#copy}}
<figcaption class="deck-exhibit-caption">{{.}}</figcaption>
{{/copy}}
`;
// Exports
module.exports = code;